<kit-bs-table [kitModel]="model"></kit-bs-table>
